import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageSelectors, setPageData } from '../../redux/reducers/pageSlice';
import BookingListWrap from '../../components/BookingListComponents/BookingListWrap';
import {
  getBookingList,
  getChessObjects,
} from '../../redux/reducers/bookingSlice';
import {
  getExternalBookings,
  getIntegrationConnections,
} from '../../redux/reducers/integrationSlice';
import { EXTERNAL_BOOKINGS_ENABLED } from '../../utils/featureFlags';
import { LoaderTypes } from '../../utils/@globalTypes';
import Loader from '../../components/Loader';
import UnavailableContent from '../../components/UnavailableContent';
import {
  getUserTarif,
  TariffsSelectors,
} from '../../redux/reducers/tariffsSlice';

import styles from './BookingList.module.scss';
import { TarifTypes } from '../../redux/types/@types';
import { addMonths, subMonths } from 'date-fns';
import { formatDate } from '../../components/Booking/functions';
import {
  ADDMONTHS_FROM_TODAY_FOR_CHECKERBOARD,
  SUBMONTHS_FROM_TODAY_FOR_CHECKERBOARD,
} from '../../utils/constants';

const BookingList = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector(
    PageSelectors.getLoadersData(LoaderTypes.BOOKING_PAGE),
  );

  useEffect(() => {
    dispatch(
      setPageData({
        pageTitle: 'Список броней',
        pageDescription: 'Учет броней, оплат и доступности номеров',
      }),
    );

    return () => {
      dispatch(setPageData(null));
    };
  }, []);

  useEffect(() => {
    dispatch(getChessObjects({}));
  }, []);

  useEffect(() => {
    const today = new Date();
    const startDate = formatDate(
      subMonths(today, SUBMONTHS_FROM_TODAY_FOR_CHECKERBOARD),
    );
    const endDate = formatDate(
      addMonths(today, ADDMONTHS_FROM_TODAY_FOR_CHECKERBOARD),
    );
    dispatch(getUserTarif());
    dispatch(getBookingList({ start: startDate, end: endDate }));
    if (EXTERNAL_BOOKINGS_ENABLED) {
      dispatch(getExternalBookings());
      dispatch(getIntegrationConnections());
    }
  }, []);
  const currentTarif = useSelector(TariffsSelectors.getCurrentTarif);

  return isLoading || !currentTarif ? (
    <Loader />
  ) : currentTarif === TarifTypes.FREE ? (
    <UnavailableContent />
  ) : (
    <BookingListWrap />
  );
};

export default BookingList;
